import React from 'react';
import AnalogueClock from 'analog-clock-react';
import './Clock.css';

function Clock(props) {

  const grayColor = '#939393';

  const clockOptions = {
    baseColor: 'white',
    borderColor: grayColor,
    border: true,
    centerColor: grayColor,
    handColors: {
      second: "#C4A9A8",
      minute: "#4572AC",
      hour: "#7DDE7F"
    },
    notchColor: grayColor,
    numbersColor: grayColor,
    showNumbers: false,
    width: "180px",
  };

  return (
    <div className="clock">
      <AnalogueClock {...clockOptions} />
    </div>
  )
}

export default Clock;